import Entitlements from './entitlements';

export {
  EntitlementsProvider,
  EntitlementsContext,
  useEntitlement,
} from './entitlements';

export default Entitlements;
